module.exports = __webpack_public_path__ + "img/West_Dunbartonshire.ea661713.png";